import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-beta-badge',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="beta-pill">Beta</span>`,
  styles: [`
    @keyframes shimmer {
      0%   { background-position: -200% center; }
      100% { background-position: 200% center; }
    }
    @keyframes pulse-glow {
      0%, 100% { box-shadow: 0 2px 6px rgba(99, 102, 241, 0.35); }
      50%       { box-shadow: 0 4px 16px rgba(99, 102, 241, 0.65); }
    }
    .beta-pill {
      display: inline-flex;
      align-items: center;
      padding: 2px 10px;
      border-radius: 20px;
      background: linear-gradient(135deg, #6366f1 0%, #3b82f6 40%, #a5b4fc 60%, #3b82f6 80%, #6366f1 100%);
      background-size: 200% auto;
      color: #fff;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.8px;
      text-transform: uppercase;
      vertical-align: middle;
      line-height: 1.4;
      animation: shimmer 2.5s linear infinite, pulse-glow 2s ease-in-out infinite;
    }
  `]
})
export class BetaBadgeComponent {}
